import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { CartDrawer } from "./components/cart/CartDrawer";
import { ChatSupport } from "./components/chat/ChatSupport";
import { ValuePropositionBanner, Header } from "./components/layout/Header";
import { HeroSection } from "./components/sections/HeroSection";
import { ProductSection } from "./components/sections/ProductSection";
import { StartProtocolSection } from "./components/sections/StartProtocolSection";
import { Footer } from "./components/layout/Footer";
import { ProductPage } from "./pages/ProductPage";
import { CheckoutPage } from "./pages/CheckoutPage";

const Home = () => {
  return (
    <div 
      className="min-h-screen"
      style={{ backgroundColor: '#F5F3EE' }}
    >
      <ValuePropositionBanner />
      <Header />
      <HeroSection />
      <ProductSection />
      <StartProtocolSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <CartDrawer />
          <ChatSupport />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:productId" element={<ProductPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
